/**
 * * using this hook to reuse auth context declaration
 */

import { useContext } from "react";
import AuthContext, { IAuthContext } from "../context/AuthContext";

/**
 * @function useAuth
 * @description Hook to reuse auth context declaration logic
 * @returns AuthContext
 */
const useAuth: () => IAuthContext = () => {
  const authObject = useContext(AuthContext);

  return { ...authObject };
};

export default useAuth;
